import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { MyContext } from "../../context/MyContext";
import PaymentMLM from "./Payment";
import Otp from "./otp/Otp";

const SignUp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentCard, setPaymentCard] = useState(false);
  const [signupData, setSignupData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    otp: "",
    referral_code: "",
  });
  const [referralCode, setReferralCode] = useState("");
  const [ref, setRef] = useState("");
  const [iv, setIv] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  // const [refral, setRefral] = useState([]);

  const [otpSent, setOtpSent] = useState(false);
  const urlParams = new URLSearchParams(location.search);
  const { exitUserId } = useContext(MyContext);
  if (exitUserId) navigate("/");
  useEffect(() => {

    async function getReferralCode() {
      const queryParams = new URLSearchParams(location.search);
      const ref = queryParams.get("ref"); // Get the 'ref' parameter
      const ivParam = queryParams.get("iv"); // Get the 'iv' parameter
      setRef(ref);
      setIv(ivParam);
      if (ref != undefined && ivParam != undefined) {
        console.log(ref);
        console.log(ivParam);
        const response = await axios.get(`${process.env.REACT_APP_NODE}refferal-code/has-ref/${ref}/iv/${ivParam}`);
        setReferralCode(response?.data?.data);
      }
    }

    getReferralCode();
  }, [location.search]);
  console.log("referral code ---> ", referralCode);
  const resendOTP = async (mobile_number) => {
    try {
      const response = await axios.post(
        `
        ${process.env.REACT_APP_PUBLIC_API_BASE_URL}user/resend-otp`,
        {
          mobile_number: signupData.mobile_number,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("OTP Resent Successful:", response.data);
      // Assuming the API returns a success message or status indicating OTP should be sent
      setOtpSent(true);
      toast.success("OTP has been resent to your mobile number.");
    } catch (error) {
      console.error(
        "Error in resending OTP:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleResendOTP = () => {
    console.log(signupData);
    const { mobile_number } = signupData;
    if (mobile_number) {
      resendOTP(mobile_number);
    } else {
      toast.error("Mobile No Not Found");
    }
  };

  const signupUser = async (signupData) => {
    try {
      console.log("Sending signup data:", signupData);
      const response = await axios.post(
        `${process.env.REACT_APP_NODE}user/signup`,
        signupData);
      console.log("Signup successful:", response);
      setOtpSent(true);
      toast.success("OTP has been sent to your mobile number.");
    } catch (error) {

      toast.error(error.response.data.message);
    }
  };

  const verifyOtp = async (otp) => {
    try {
       console.log("==========>   ",otp)
      const { mobile_number } = signupData;
      console.log("Verifying OTP:", otp);
      const response = await axios.post(
        `${process.env.REACT_APP_NODE}user/signup/verifyOTP`,
        { otp, mobile_number }
      );
      console.log("OTP verification successful:", response);
      const userid = response.data.id;
      const token = response.data.token;
      toast.success("OTP verified successfully!");
      console.log("payment card ---> ", paymentCard);
      localStorage.setItem("userId", userid);
      localStorage.setItem("token", token);
      setPaymentCard(true);      
      if (referralCode == "") {
        console.log("hello is now is working ")
          navigate("/")
          // console.log("hello is now is working ",responseLink)
      }  else if (referralCode != "") {
        console.log("referral code is ---> ", referralCode);
        const response = await axios.post(
          `${process.env.REACT_APP_NODE}signup-user/referral-code`,
          {
            referral_code: referralCode,
            new_user_id: userid
          }
        );
        console.log("ref response ->", response);
        navigate("/")
      }
  
    } catch (error) {
      console.error(
        "Error during OTP verification:",
        error.response ? error.response.data : error.message
      );
    }
  };
  function handleCloseOtp(){
    console.log('close')
    setOtpSent(false)
  }

  const handleSignup = () => {
    const { first_name, last_name, email, mobile_number } = signupData;
    if (first_name && last_name && email && mobile_number) {
      signupUser(signupData);
    } else {
      toast.warning("Please fill all fields");
    }
    setShowOtp(true);
  };

  const handleOtpVerification = () => {
    if (signupData.otp) {
      verifyOtp(signupData.otp);
    } else {
      toast.success("Please enter the OTP sent to your mobile number");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "referral_code") {
      setReferralCode(value);
    } else if (name === "mobile_number") {
      if (/^\d*$/.test(value) && value.length <= 10) {
        // Limit to 10 digits
        setSignupData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
      setSignupData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleBackSignup = () => {
    navigate("/")
  }

  return (
    <section className="">
      {!paymentCard ? (
        <div className="">
          <div className="flex items-center justify-center min-h-screen p-6">
            <div className="flex flex-col md:flex-row w-full max-w-5xl 2xl:max-w-7xl bg-white shadow-2xl rounded-lg overflow-hidden">
              <button
                onClick={handleBackSignup}
                className="absolute top-4 2xl:top-10 right-0  sm:right-4 md:right-4 lg:right-4 xl:right-28 2xl:right-32 bg-[#a855f7] text-white px-3 py-2 rounded-full text-sm "
              >
                ✖
              </button>
              {/* Left Side - Image */}
              <div
                className="hidden md:flex w-1/2 bg-cover bg-center"
                style={{
                  backgroundImage:
                    'url("https://adrack.com/wp-content/uploads/2021/12/signup.png")',
                }}
              ></div>

              {/* Right Side - Form */}
              <div className="w-full md:w-1/2 p-10 flex flex-col justify-center">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
                  Create Your Account
                </h2>
                <div className="flex gap-4">
                  <input
                    type="text"
                    name="first_name"
                    value={signupData.first_name}
                    onChange={handleChange}
                    placeholder="First Name"
                    className="w-1/2 p-3 border rounded-lg focus:ring-2 focus:ring-blue-400"
                  />
                  <input
                    type="text"
                    name="last_name"
                    value={signupData.last_name}
                    onChange={handleChange}
                    placeholder="Last Name"
                    className="w-1/2 p-3 border rounded-lg focus:ring-2 focus:ring-blue-400"
                  />
                </div>
                <input
                  type="email"
                  name="email"
                  value={signupData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full p-3 mt-4 border rounded-lg focus:ring-2 focus:ring-blue-400"
                />
                <input
                  type="text"
                  name="mobile_number"
                  value={signupData.mobile_number}
                  onChange={handleChange}
                  placeholder="Mobile Number"
                  className="w-full p-3 mt-4 border rounded-lg focus:ring-2 focus:ring-blue-400"
                />
                <input
                  type="text"
                  name="referral_code"
                  value={referralCode}
                  onChange={handleChange}
                  placeholder="Referral Code (Optional)"
                  className="w-full p-3 mt-4 border rounded-lg focus:ring-2 focus:ring-blue-400"
                />
                {!otpSent ? (
                  <button
                    onClick={handleSignup}
                    className="w-full mt-6 bg-blue-600 text-white p-3 rounded-lg text-lg font-semibold hover:bg-blue-700 shadow-lg transition"
                  >
                    Send OTP
                  </button>
                ) : (
                  <>
                    {/* <input
                      type="text"
                      name="otp"
                      value={signupData.otp}
                      onChange={handleChange}
                      placeholder="Enter OTP"
                      className="w-full p-3 mt-4 border rounded-lg focus:ring-2 focus:ring-blue-400"
                    /> */}[]
                    <Otp onClose={handleCloseOtp} otpSend={verifyOtp} resendSignupOtp={handleSignup} signUp={true} />
                    {/* <button
                      onClick={handleOtpVerification}
                      className="w-full mt-6 bg-green-500 text-white p-3 rounded-lg text-lg font-semibold hover:bg-green-600 shadow-lg transition"
                    >
                      Verify OTP  
                    </button> */}
                  </>
                )}
                <p className="mt-6 text-center text-gray-600">
                  Already have an account?{" "}
                  <Link
                    to="/login-user"
                    className="text-blue-500 hover:underline font-semibold"
                  >
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </section>
  );
};

export default SignUp;